export const itemNameCellStyles = {
  display: 'flex',
  flexDirection: 'column',
};

export const checklistNoteStyles = {
  color: 'text.secondary',
};
